import React from 'react'
import MaterialSymbol from '../material-symbol'

const Cake = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="cake" {...props} />
))

Cake.displayName = 'Cake'

export default Cake
